/* ==========================================================================
   Marnetic custom facets — Availability + Price + AJAX sorting
   Vintage-theme safe: no custom elements, no framework, delegated listeners.
   ========================================================================== */

(function () {
  'use strict';

  var DEBOUNCE = 450;
  var timer = null;

  function root() {
    return document.querySelector('.facets-wrapper');
  }

  function form() {
    return document.getElementById('FacetFiltersForm');
  }

  function grid() {
    return document.getElementById('Collection');
  }

  function isAjax() {
    var el = root();
    return !!el && el.getAttribute('data-facets-ajax') === 'true' && !!grid();
  }

  function sectionId() {
    var el = root();
    return el ? el.getAttribute('data-facets-section') : '';
  }

  function drawerOpen() {
    var el = root();
    return !!el && el.classList.contains('is-open');
  }

  /* ---------- URL / state ---------- */

  function serialize() {
    var f = form();
    if (!f) return '';
    var out = new URLSearchParams();
    new FormData(f).forEach(function (value, key) {
      if (value === null) return;
      var v = String(value).trim();
      if (v === '') return;
      out.append(key, v);
    });
    return out.toString();
  }

  function syncFromUrl() {
    var f = form();
    if (!f) return;
    var params = new URLSearchParams(window.location.search);

    Array.prototype.forEach.call(f.querySelectorAll('input[type="checkbox"]'), function (cb) {
      cb.checked = params.getAll(cb.name).indexOf(cb.value) !== -1;
    });

    Array.prototype.forEach.call(f.querySelectorAll('input[type="number"]'), function (input) {
      input.value = params.get(input.name) || '';
    });

    var sort = f.querySelector('input[name="sort_by"]');
    if (sort && params.get('sort_by')) sort.value = params.get('sort_by');
  }

  /* The section endpoint echoes section_id back into paginate URLs, so strip it. */
  function cleanPagination() {
    var g = grid();
    if (!g) return;
    Array.prototype.forEach.call(g.querySelectorAll('.pagination a[href]'), function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.delete('section_id');
        a.setAttribute('href', u.pathname + (u.search ? u.search : ''));
      } catch (e) {
        /* leave the link alone */
      }
    });
  }

  function setLoading(state) {
    var g = grid();
    if (g) g.classList.toggle('facets-loading', !!state);
  }

  function scrollToGrid() {
    var el = root();
    if (!el) return;
    var anchor = el.querySelector('.facets-filter-item') || el;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  function closeAllDropdowns() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.facets-disclosure[open], .sort-dd__details[open]'),
      function (d) {
        d.open = false;
      }
    );
  }

  /* ---------- Apply ---------- */

  function apply(params, push) {
    var path = window.location.pathname;
    var newUrl = params ? path + '?' + params : path;

    if (push !== false) {
      history.pushState({ facets: params || '' }, '', newUrl);
    }

    if (!isAjax()) {
      window.location.href = newUrl;
      return;
    }

    setLoading(true);

    var url = path + '?section_id=' + encodeURIComponent(sectionId()) + (params ? '&' + params : '');

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Section request failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('Collection');
        var oldGrid = grid();
        if (newGrid && oldGrid) oldGrid.innerHTML = newGrid.innerHTML;

        var newWrapper = doc.querySelector('.facets-wrapper');
        var oldWrapper = root();
        if (newWrapper && oldWrapper) oldWrapper.innerHTML = newWrapper.innerHTML;

        cleanPagination();
        syncFromUrl();
        setLoading(false);

        // Sort/filter ke baad nayi prices ko bhi convert karo
        try {
          if (typeof DoublyGlobalCurrency !== 'undefined' && DoublyGlobalCurrency.convertAll) DoublyGlobalCurrency.convertAll();
          if (typeof Currency !== 'undefined' && Currency.convertAll) Currency.convertAll();
          if (window.currency_dropdown && typeof convertCurrencies === 'function') convertCurrencies();
        } catch (err) {}

        if (typeof window.cswInitAll === 'function') window.cswInitAll();
        document.dispatchEvent(new CustomEvent('facets:updated'));
      })
      .catch(function () {
        window.location.href = newUrl;
      });
  }

  function debouncedApply() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      apply(serialize());
    }, DEBOUNCE);
  }

  function applyFromHref(href) {
    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.delete('section_id');
      apply(u.searchParams.toString());
    } catch (e) {
      window.location.href = href;
    }
  }

  /* ---------- Drawer ---------- */

  function openDrawer() {
    var el = root();
    if (!el) return;
    el.classList.add('is-open');
    document.body.classList.add('facets-drawer-open');
    var btn = el.querySelector('.facets-mobile-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    var el = root();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('facets-drawer-open');
    var btn = el.querySelector('.facets-mobile-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  /* ---------- Events ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('.facets-mobile-toggle')) {
      openDrawer();
      return;
    }

    if (t.closest('.facets-drawer-close') || t.closest('.facets-overlay')) {
      closeDrawer();
      return;
    }

    if (t.closest('.facets-apply-button')) {
      closeDrawer();
      apply(serialize());
      return;
    }

    /* Sorting */
    var sortLink = t.closest('.sort-dd__option');
    if (sortLink) {
      e.preventDefault();
      var sortParams = new URLSearchParams(window.location.search);
      sortParams.set('sort_by', sortLink.getAttribute('data-sort'));
      sortParams.delete('page');
      sortParams.delete('section_id');
      closeAllDropdowns();
      apply(sortParams.toString());
      return;
    }

    var chip = t.closest('.active-facet, .facets-clear-all');
    if (chip && chip.getAttribute('href')) {
      e.preventDefault();
      closeDrawer();
      applyFromHref(chip.getAttribute('href'));
      return;
    }

    var page = t.closest('#Collection .pagination a[href]');
    if (page && isAjax()) {
      e.preventDefault();
      applyFromHref(page.getAttribute('href'));
      scrollToGrid();
      return;
    }
  });

  /* Close open dropdowns on outside click */
  document.addEventListener('click', function (e) {
    if (drawerOpen()) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.facets-disclosure[open], .sort-dd__details[open]'),
      function (d) {
        if (!d.contains(e.target)) d.open = false;
      }
    );
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerOpen()) {
      closeDrawer();
      return;
    }
    closeAllDropdowns();
  });

  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('#FacetFiltersForm')) return;
    if (drawerOpen()) return;
    debouncedApply();
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('#FacetFiltersForm input[type="number"]')) return;
    if (drawerOpen()) return;
    debouncedApply();
  });

  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'FacetFiltersForm') return;
    e.preventDefault();
    closeDrawer();
    apply(serialize());
  });

  window.addEventListener('popstate', function () {
    var params = window.location.search.replace(/^\?/, '');
    apply(params, false);
  });

  /* ---------- Init ---------- */

  function init() {
    if (!root()) return;
    syncFromUrl();
    cleanPagination();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();